export const Plus = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6562 24.2939L11.6562 0.606445L12.6562 0.606445L12.6562 24.2939H11.6562Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6562 24.2939L11.6562 0.606445L12.6562 0.606445L12.6562 24.2939H11.6562Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.3125 11.9502L24 11.9502V12.9502L0.3125 12.9502L0.3125 11.9502Z"
        fill="currentColor"
      />
    </svg>
  )
}
